import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AngularFireAuth } from 'angularfire2/auth';
import { User as FirebaseUser } from 'firebase';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/first';

import { User } from '../models/user';
import { UserService } from './user.service';

@Injectable()
export class AppGuardService implements CanActivate {

  constructor(
    private router: Router,
    private afAuth: AngularFireAuth,
    private userService: UserService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return Observable.create((observer: Observer<boolean>) => {
      this.afAuth.authState
        .first()
        .subscribe((firebaseUser: FirebaseUser | null) => {
          if (firebaseUser) {
            this.userService.getUser(firebaseUser.uid)
              .first()
              .subscribe((user: User | null) => {
                if (user) {
                  if (user && user.roleIsThinkBIT) {
                    this.router.navigateByUrl('/companies');
                  } else if (user && user.roleIsCompany) {
                    this.router.navigate(['/companies', user.id, 'events']);
                  }
                }

                observer.next(false);
                observer.complete();
              });
          } else {
            observer.next(false);
            observer.complete();
          }
        });
    });
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/services/app-guard.service.ts